<template>
    <div v-if="picModal">
        <!--参数说明 -->
        <!--options:zoomRatio缩放指数 ,hidden隐藏事件 -->
        <Viewer  v-if="diskFileName" :options="{zoomRatio:0.2, hidden:handleHidden,url:handleUrl,}"   @inited="inited">
            <img v-show="false" :src="'/static/file/'+diskFileName" :alt="diskFileName">
        </Viewer>
        <Viewer v-else :options="{zoomRatio:0.2, hidden:handleHidden,url:handleUrl,}" :images="uploadList"  @inited="inited">
            <img v-show="false" v-for="(src,index) in uploadList" :src="'/static/file/'+src.diskFileName" :key="index" :alt="src.fileName">
        </Viewer>
    </div>
</template>
<style scoped>

</style>
<script>

    import 'viewerjs/dist/viewer.css'
    import {component as Viewer} from "v-viewer"
    export default {
        components: {
            Viewer
        },
        data(){
            return{

            };
        },
        props: {
            /*弹出框显示隐藏*/
            picModal:{
                type:Boolean,
                default:false
            },
            /*当前下标*/
            imgIndex:{
                type: [String, Number],
                default:0,
            },

            /*图片列表*/
            uploadList:{
                type: Array,
            },
            /*单个图片*/
            diskFileName:{
                type:String,
            },
        },
        mounted(){

        },
        watch: {

        },
        methods:{
            //预览实例关闭时 通知父组件预览关闭了
            handleHidden(){
                this.$emit('update:picModal', false);
            },
            //预览实例初始化后 打开预览
            inited (viewer) {
                this.$viewer = viewer;
                if(this.picModal===true){
                    this.$viewer.view(this.imgIndex);
                }
            },
            //非图片格式显示
            handleUrl(img){
                //这里设置单个图片时的名称
                let reg=/\.(jpg|jpeg|png|bmp|gif)$/i;
                if(!reg.test(img.src)){
                    return '/src/assets/error404.gif';
                }
            }
        },
    };
</script>
